<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem(this.myOption.storage.user, JSON.stringify(this.$store.state.user))
    })
  },
  mounted () {
    document.getElementsByTagName('title')[0].textContent = this.myOption.name
  }
}
</script>

<style>
  #app{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .el-date-editor .el-range-separator{
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue